module.exports = require("babel-core/polyfill");



//////////////////
// WEBPACK FOOTER
// ./~/babel/polyfill.js
// module id = 83
// module chunks = 0